import { Component } from '@angular/core';

@Component({
  selector: 'app-avaliacoes-card',
  standalone: false,
  templateUrl: './avaliacoes-card.component.html',
  styleUrl: './avaliacoes-card.component.scss'
})
export class AvaliacoesCardComponent {

}
